'use client';
import { cn } from '@dolcevia/lib/utils';
import './booqable-datepicker.css';
export const BooqableDatePicker = ({ className }: { className?: string }) => (
  <div className={cn('booqable-datepicker', className)} />
);

export default BooqableDatePicker;
